import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useParams } from 'react-router-dom';
import './App.css';
import atoLogo from './atoLogo.jpg';

// Import components (we'll create these as sections in this file for minimal structure)
import Home from './Home';

// Component sections for minimal structure
const Philanthropy = () => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedCard, setSelectedCard] = React.useState(null);

  const cards = [
    {
      title: 'ATO Car Show',
      shortDesc: 'Yearly event showcasing classic cars and raising funds for our local Veteran of Foreign Wars. Join us for a day of fun, food, and philanthropy!',
      image: 'https://images.unsplash.com/photo-1464983953574-0892a716854b?w=400',
      details: 'The ATO Car Show is our flagship philanthropy event, held annually to support the Starkville Veteran of Foreign Wars. We showcase hundreds of classic and custom cars, offer food trucks, live music, and family-friendly activities. All proceeds go directly to veterans\' programs. Last year, we raised over $15,000 and had over 2,000 attendees. Volunteers needed for setup, registration, and event coordination.'
    },
    {
      title: 'Habitat for Humanity',
      shortDesc: 'Building homes and hope for Starkville families.',
      image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=400',
      details: 'Through our partnership with Habitat for Humanity, ATO brothers dedicate weekends to building homes for families in need. We provide labor, materials coordination, and community outreach. Our chapter has helped build 12 homes in the past 5 years, impacting over 50 family members. This hands-on service teaches valuable construction skills while directly improving our community.'
    },
    {
      title: 'Bully\'s Closet',
      shortDesc: 'Volunteering as coaches and event staff, celebrating every athlete.',
      image: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?w=400',
      details: 'Bully\'s Closet is a Starkville organization providing adaptive sports equipment for children and adults with disabilities. ATO brothers serve as coaches, referees, and event volunteers for basketball, soccer, and track events. We help organize monthly games and annual tournaments, fostering inclusion and celebrating athletic achievement for all abilities.'
    },
    {
      title: 'Campus Clean-Up',
      shortDesc: 'Quarterly projects keeping MSU beautiful and sustainable.',
      image: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?w=400',
      details: 'Our quarterly campus clean-up initiatives keep Mississippi State University beautiful and environmentally conscious. Brothers collect litter, maintain green spaces, and promote recycling awareness. We coordinate with MSU facilities and organize large group clean-ups during fall and spring semesters, removing hundreds of pounds of waste and educating students about sustainability.'
    }
  ];

  return (
    <section className="philanthropy-section">
      <div className="content">
        <div style={{ backgroundColor: 'var(--azure-light)', textAlign: 'center', textWrap: 'break-word', padding: '1rem', margin: '0', width: '100%'}}>
          <h2 style={{ textAlign: 'center', color: 'var(--fraternity-gold)'}}>Philanthropy</h2>
          <h3>Impacting Lives, Building Brotherhood</h3>
          <p style={{ color: 'white' }}>
            At Alpha Tau Omega, philanthropy is more than just service—it's a core part of our brotherhood. We strive to create lasting change on campus and in the Starkville community through hands-on involvement, fundraising, and leadership.
          </p>
        </div>
        <div className="philanthropy-highlights">
          {cards.map((card, index) => (
            <div className="highlight-card" key={index} onClick={() => { setSelectedCard(card); setModalOpen(true); }}>
              {index % 2 === 0 ? (
                <>
                  <img className="highlight-image" src={card.image} alt={card.title} />
                  <div className="highlight-content">
                    <h4>{card.title}</h4>
                    <p>{card.shortDesc}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="highlight-content">
                    <h4>{card.title}</h4>
                    <p>{card.shortDesc}</p>
                  </div>
                  <img className="highlight-image" src={card.image} alt={card.title} />
                </>
              )}
              <button className="learn-more-btn floating" onClick={() => { setSelectedCard(card); setModalOpen(true); }}>Learn More</button>
            </div>
          ))}
        </div>
        <div className="stats">
          <div className="stat">
            <h4>500+</h4>
            <p>Service Hours Annually</p>
          </div>
          <div className="stat">
            <h4>$10,000+</h4>
            <p>Raised for Local Charities</p>
          </div>
          <div className="stat">
            <h4>12</h4>
            <p>Major Philanthropy Events</p>
          </div>
        </div>
        <div className="call-to-action">
          <h1 style={{color: 'var(--primary-azure)'}}>Want to Get Involved?</h1>
          <h3>
            Whether you're a student, alumni, or community member, join us in making a difference. <a href="/contact">Contact us</a> to volunteer or partner with ATΩ!
          </h3>
        </div>
      </div>
      {modalOpen && selectedCard && (
        <div className="modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setModalOpen(false)}>×</button>
            <img src={selectedCard.image} alt={selectedCard.title} style={{width: '100%', height: '300px', objectFit: 'cover', borderRadius: '10px', marginBottom: '1rem'}} />
            <h2 style={{color: 'var(--primary-azure)', marginBottom: '1rem'}}>{selectedCard.title}</h2>
            <p style={{lineHeight: '1.6'}}>{selectedCard.details}</p>
          </div>
        </div>
      )}
    </section>
  );
};

const Events = () => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedEvent, setSelectedEvent] = React.useState(null);

  const events = [
    {
      title: 'Fall Rush Week',
      date: 'September 15-20, 2025',
      shortDesc: 'Join us for a week of brotherhood, food, and fun. Meet current members and learn what ATO is all about.',
      image: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=400',
      details: 'Fall Rush Week is our annual recruitment period where prospective members experience ATO brotherhood firsthand. Activities include daily social events, informational sessions, chapter house tours, and brotherhood dinners. Rush chairs and current members host events designed to showcase our values of leadership, academics, and service. This week culminates in bid day, where new members are welcomed into the fraternity. Over 100 students typically participate each year.'
    },
    {
      title: 'Homecoming Tailgate',
      date: 'November 2, 2025',
      shortDesc: 'Celebrate MSU Homecoming with the brotherhood. Food, games, and Bulldog pride!',
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400',
      details: 'The ATO Homecoming Tailgate is a highlight of the fall semester, bringing together current members, alumni, and families for an unforgettable day of MSU spirit. We set up in the Grove with food trucks, games, live music, and plenty of maroon and white pride. The tailgate serves as both a reunion and a recruitment opportunity, showcasing our brotherhood to the wider MSU community. We typically host over 200 attendees and raise funds for our philanthropy initiatives.'
    },
    {
      title: 'Winter Formal',
      date: 'December 14, 2025',
      shortDesc: 'An elegant evening celebrating our brotherhood and achievements of the semester.',
      image: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=400',
      details: 'Winter Formal is our annual black-tie gala celebrating the accomplishments of the semester and honoring our graduating seniors. Held at a prestigious Starkville venue, the event features fine dining, dancing, and recognition of academic and leadership achievements. Brothers bring dates for an elegant evening of celebration. The formal also serves as a major fundraising event for our philanthropy partners, with proceeds supporting local charities and our service initiatives.'
    },
    {
      title: 'Brotherhood Retreat',
      date: 'January 25-26, 2026',
      shortDesc: 'Annual weekend retreat for team building, leadership development, and planning.',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400',
      details: 'The annual Brotherhood Retreat is a transformative weekend where brothers disconnect from campus life to focus on personal growth and chapter development. Held at a scenic retreat center, activities include team-building exercises, leadership workshops, goal-setting sessions, and strategic planning for the upcoming year. The retreat strengthens bonds between brothers and aligns our chapter with ATO\'s core values. Brothers return renewed and focused on excellence in academics, leadership, and service.'
    }
  ];

  return (
    <section className="events-section">
      <div className="content">
        <div style={{ backgroundColor: 'var(--azure-light)', textAlign: 'center', padding: '1rem', margin: '0', width: '100%'}}>
          <h2 style={{ textAlign: 'center', color: 'var(--fraternity-gold)' }}>Events</h2>
          <h3>Building Brotherhood Through Shared Experiences</h3>
          <p style={{ color: 'white' }}>
            From recruitment to reunions, ATO events create lasting memories and strengthen our brotherhood. Join us for social gatherings, leadership development, and community celebrations.
          </p>
        </div>
        <div className="events-highlights">
          {events.map((event, index) => (
            <div className="event-card" key={index} onClick={() => { setSelectedEvent(event); setModalOpen(true); }}>
              {index % 2 === 0 ? (
                <>
                  <img className="event-image" src={event.image} alt={event.title} />
                  <div className="event-content">
                    <h4>{event.title}</h4>
                    <p className="event-date" style={{color: 'var(--fraternity-gold)', fontWeight: '600', marginBottom: '0.5rem'}}>{event.date}</p>
                    <p>{event.shortDesc}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="event-content">
                    <h4>{event.title}</h4>
                    <p className="event-date" style={{color: 'var(--fraternity-gold)', fontWeight: '600', marginBottom: '0.5rem'}}>{event.date}</p>
                    <p>{event.shortDesc}</p>
                  </div>
                  <img className="event-image" src={event.image} alt={event.title} />
                </>
              )}
              <button className="learn-more-btn floating" onClick={() => { setSelectedEvent(event); setModalOpen(true); }}>Learn More</button>
            </div>
          ))}
        </div>
        <div className="events-stats">
          <div className="stat">
            <h4>50+</h4>
            <p>Events Annually</p>
          </div>
          <div className="stat">
            <h4>1000+</h4>
            <p>Attendees Each Year</p>
          </div>
          <div className="stat">
            <h4>25+</h4>
            <p>Years of Tradition</p>
          </div>
        </div>
        <div className="events-cta">
          <h1>Ready to Join the Brotherhood?</h1>
          <h3>
            Experience the ATΩ difference through our events. <a href="/contact">Contact us</a> to learn more about rush or upcoming gatherings!
          </h3>
        </div>
      </div>
      {modalOpen && selectedEvent && (
        <div className="modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setModalOpen(false)}>×</button>
            <img src={selectedEvent.image} alt={selectedEvent.title} style={{width: '100%', height: '300px', objectFit: 'cover', borderRadius: '10px', marginBottom: '1rem'}} />
            <h2 style={{color: 'var(--primary-azure)', marginBottom: '0.5rem'}}>{selectedEvent.title}</h2>
            <p style={{color: 'var(--fraternity-gold)', fontWeight: '600', marginBottom: '1rem'}}>{selectedEvent.date}</p>
            <p style={{lineHeight: '1.6'}}>{selectedEvent.details}</p>
          </div>
        </div>
      )}
    </section>
  );
};

const Alumni = () => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedAlumni, setSelectedAlumni] = React.useState(null);
  const [addToDirectory, setAddToDirectory] = React.useState(false);

  const notableAlumni = [
    {
      name: 'John Smith',
      graduation: '1998',
      title: 'CEO, Mississippi Tech Solutions',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300',
      bio: 'John Smith graduated from MSU with a degree in Computer Science and founded Mississippi Tech Solutions, now a leading software company serving clients across the Southeast. He remains actively involved with the chapter, serving as a mentor to current students and hosting internship opportunities.',
      achievements: 'Founded successful tech company, Created 200+ jobs, Active philanthropist, Chapter mentor',
      contact: 'john.smith@msutech.com'
    },
    {
      name: 'Mike Johnson',
      graduation: '2005',
      title: 'State Representative, Mississippi',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300',
      bio: 'Mike Johnson serves in the Mississippi State Legislature, representing District 45. After graduating with a degree in Political Science, he worked in public policy before running for office. He credits his ATO experience with developing the leadership skills that prepared him for public service.',
      achievements: 'Elected State Representative, Authored education reform legislation, Community advocate, Young alumni leader',
      contact: 'rep.johnson@ms.gov'
    },
    {
      name: 'David Brown',
      graduation: '2012',
      title: 'NFL Player, New Orleans Saints',
      image: 'https://images.unsplash.com/photo-1543326727-cf6c39e8f84c?w=300',
      bio: 'David Brown is a linebacker for the New Orleans Saints, drafted in the 3rd round after an outstanding college career at MSU. He was a key member of the Bulldogs\' SEC Championship team and continues to inspire current student-athletes through his success in professional football.',
      achievements: 'NFL Draft pick, SEC Champion, Academic All-American, Philanthropy ambassador',
      contact: 'david.brown@saints.nfl.com'
    },
    {
      name: 'Sarah Williams',
      graduation: '2010',
      title: 'Cardiovascular Surgeon, UMMC',
      image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=300',
      bio: 'Dr. Sarah Williams is a leading cardiovascular surgeon at the University of Mississippi Medical Center. She completed her medical training at Johns Hopkins and returned to Mississippi to serve her home state. She volunteers her time mentoring pre-med students in the chapter.',
      achievements: 'Board-certified surgeon, Published medical research, Medical student mentor, Community health advocate',
      contact: 's.williams@umc.edu'
    }
  ];

  const alumniBenefits = [
    {
      title: 'Professional Networking',
      description: 'Connect with successful alumni across various industries for career opportunities and mentorship.',
      icon: '🤝'
    },
    {
      title: 'Chapter Updates',
      description: 'Stay informed about chapter activities, achievements, and upcoming events through our digital newsletter.',
      icon: '📧'
    },
    {
      title: 'Reunion Events',
      description: 'Join annual reunions and special events to reconnect with old friends and make new memories.',
      icon: '🎉'
    },
    {
      title: 'Philanthropy Opportunities',
      description: 'Continue your legacy of service through alumni-led charitable initiatives and volunteer programs.',
      icon: '❤️'
    },
    {
      title: 'Mentorship Program',
      description: 'Receive guidance from experienced alumni in your career path and personal development.',
      icon: '🎓'
    },
    {
      title: 'Alumni Directory',
      description: 'Access our private alumni directory for networking and professional connections.',
      icon: '📚'
    }
  ];

  const careerOutcomes = [
    { industry: 'Business & Finance', percentage: 28, examples: 'CEOs, Investment Bankers, Entrepreneurs' },
    { industry: 'Healthcare', percentage: 18, examples: 'Physicians, Surgeons, Healthcare Executives' },
    { industry: 'Law', percentage: 15, examples: 'Attorneys, Judges, Legal Executives' },
    { industry: 'Engineering', percentage: 12, examples: 'Civil Engineers, Software Engineers, Consultants' },
    { industry: 'Education', percentage: 10, examples: 'Professors, Administrators, Researchers' },
    { industry: 'Government & Public Service', percentage: 8, examples: 'Politicians, Policy Advisors, Civil Servants' },
    { industry: 'Sports & Entertainment', percentage: 5, examples: 'Athletes, Coaches, Media Professionals' },
    { industry: 'Other', percentage: 4, examples: 'Non-profit Leaders, Entrepreneurs, Consultants' }
  ];

  const alumniTestimonials = [
    {
      name: 'James Wilson',
      graduation: '2001',
      quote: 'ATO gave me the leadership skills and network that launched my career. The brotherhood extends far beyond college - I still rely on my ATO brothers for advice and opportunities.',
      position: 'Managing Director, Goldman Sachs'
    },
    {
      name: 'Dr. Maria Rodriguez',
      graduation: '2008',
      quote: 'The mentorship I received from ATO alumni helped me navigate medical school and residency. Now I pay it forward by mentoring current pre-med students in the chapter.',
      position: 'Chief of Surgery, Baptist Memorial Hospital'
    },
    {
      name: 'Robert Chen',
      graduation: '2015',
      quote: 'ATO taught me the value of service and leadership. My fraternity experience opened doors to internships and job opportunities that shaped my career in tech.',
      position: 'VP of Engineering, Microsoft'
    }
  ];

  return (
    <section className="alumni-section">
      <div className="content">
        <div className="alumni-hero">
          <div className="alumni-hero-content">
            <h1>ATO Alumni Network</h1>
            <h2>Excellence Beyond Graduation</h2>
            <p>Our brotherhood extends far beyond the college years. ATO alumni lead in every industry, giving back to their communities and mentoring the next generation.</p>
            <div className="alumni-hero-stats">
              <div className="hero-stat">
                <span className="stat-number">500+</span>
                <span className="stat-label">Active Alumni</span>
              </div>
              <div className="hero-stat">
                <span className="stat-number">25+</span>
                <span className="stat-label">States</span>
              </div>
              <div className="hero-stat">
                <span className="stat-number">$2M+</span>
                <span className="stat-label">Alumni Impact</span>
              </div>
            </div>
          </div>
          <div className="alumni-hero-decoration">
            <div className="decoration-circle"></div>
            <div className="decoration-line"></div>
          </div>
        </div>

        <div className="alumni-showcase">
          <div className="showcase-header">
            <h2>Distinguished Alumni</h2>
            <p>Meet brothers who exemplify ATO's commitment to leadership, service, and excellence</p>
          </div>
          <div className="alumni-mosaic">
            {notableAlumni.map((alumni, index) => (
              <div className={`alumni-mosaic-item ${index % 2 === 0 ? 'featured' : 'standard'}`} key={index}>
                <div className="mosaic-image">
                  <img src={alumni.image} alt={alumni.name} />
                  <div className="image-overlay">
                    <button className="mosaic-learn-more" onClick={() => { setSelectedAlumni(alumni); setModalOpen(true); }}>
                      View Profile
                    </button>
                  </div>
                </div>
                <div className="mosaic-content">
                  <h3>{alumni.name}</h3>
                  <p className="mosaic-graduation">Class of {alumni.graduation}</p>
                  <p className="mosaic-title">{alumni.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="alumni-pathways">
          <h2>Career Pathways</h2>
          <p>ATO brothers excel across diverse industries, proving that our values prepare you for success in any field</p>
          <div className="pathways-grid">
            {careerOutcomes.map((outcome, index) => (
              <div className="pathway-card" key={index}>
                <div className="pathway-percentage">{outcome.percentage}%</div>
                <h3>{outcome.industry}</h3>
                <p>{outcome.examples}</p>
                <div className="pathway-bar">
                  <div className="pathway-fill" style={{width: `${outcome.percentage * 2}%`}}></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="alumni-testimonials">
          <h2>Voices of Success</h2>
          <div className="testimonials-mosaic">
            {alumniTestimonials.map((testimonial, index) => (
              <div className="testimonial-mosaic-item" key={index}>
                <div className="testimonial-content">
                  <blockquote>"{testimonial.quote}"</blockquote>
                  <div className="testimonial-author">
                    <strong>{testimonial.name}</strong>
                    <span>Class of {testimonial.graduation}</span>
                    <span>{testimonial.position}</span>
                  </div>
                </div>
                <div className="testimonial-accent"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="alumni-services">
          <h2 style={{color: 'white'}}>Alumni Services & Resources</h2>
          <div className="services-hub">
            {alumniBenefits.map((benefit, index) => (
              <div className="service-hub-item" key={index}>
                <div className="service-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="alumni-connect">
          <div className="connect-content">
            <h2>Stay Connected</h2>
            <p>Join our alumni community and never miss an opportunity to reconnect with your brotherhood</p>
            <form className="connect-form">
              <div className="form-row">
                <input type="text" placeholder="First Name" />
                <input type="text" placeholder="Last Name" />
              </div>
              <input type="email" placeholder="Email Address" />
              <div className="form-row">
                <input type="text" placeholder="Graduation Year" />
                <input type="text" placeholder="Field of Study" />
              </div>
              <div className="form-row">
                <input type="text" placeholder="Current Company" />
                <input type="text" placeholder="Industry" />
              </div>

              <div className="directory-checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={addToDirectory}
                    onChange={(e) => setAddToDirectory(e.target.checked)}
                  />
                  <span>Add me to the alumni directory</span>
                </label>
              </div>

              {addToDirectory && (
                <div className="directory-fields">
                  <div className="form-row">
                    <input type="tel" placeholder="Phone Number" />
                  </div>
                  <div className="form-row">
                    <input type="text" placeholder="Current City" />
                    <input type="text" placeholder="State" />
                  </div>
                  <input type="password" placeholder="Name the 2021 Nexus Chapter president (FirstName LastName)" />
                </div>
              )}

              <button type="submit" className={addToDirectory ? 'directory-submit' : ''}>
                {addToDirectory ? 'Join & Add to Directory' : 'Join the Network'}
              </button>
            </form>
            <p className="connect-note">Your privacy is protected. We never share your information.</p>
          </div>
          <div className="connect-visual">
            <div className="connect-network"></div>
          </div>
        </div>

        <div className="alumni-legacy">
          <h2>Legacy of Excellence</h2>
          <p>Your ATO experience is just the beginning. Our alumni network ensures that the bonds of brotherhood and the pursuit of excellence continue throughout your life.</p>
          <div className="legacy-actions">
            <a href="/contact" className="legacy-link">Get Involved</a>
            <a href="/contact" className="legacy-link secondary">Make a Gift</a>
          </div>
        </div>
      </div>

      {modalOpen && selectedAlumni && (
        <div className="modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setModalOpen(false)}>×</button>
            <img src={selectedAlumni.image} alt={selectedAlumni.name} style={{width: '150px', height: '150px', borderRadius: '50%', objectFit: 'cover', marginBottom: '1rem'}} />
            <h2 style={{color: 'var(--primary-azure)', marginBottom: '0.5rem'}}>{selectedAlumni.name}</h2>
            <p style={{color: 'var(--fraternity-gold)', fontWeight: '600', marginBottom: '1rem'}}>Class of {selectedAlumni.graduation}</p>
            <p style={{fontWeight: '600', marginBottom: '1rem'}}>{selectedAlumni.title}</p>
            <p style={{lineHeight: '1.6', marginBottom: '1.5rem'}}>{selectedAlumni.bio}</p>
            <h4 style={{color: 'var(--primary-azure)', marginBottom: '0.5rem'}}>Key Achievements:</h4>
            <ul style={{lineHeight: '1.6', marginBottom: '1.5rem'}}>
              {selectedAlumni.achievements.split(', ').map((achievement, i) => (
                <li key={i}>{achievement}</li>
              ))}
            </ul>
            <p style={{fontSize: '0.9rem', color: 'var(--text-light)'}}>
              <strong>Contact:</strong> {selectedAlumni.contact}
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

const Gallery = () => {
  const [selectedAlbum, setSelectedAlbum] = React.useState(null);
  const [modalOpen, setModalOpen] = React.useState(false);

  const albums = [
    {
      id: 'events',
      title: 'Events & Socials',
      coverImage: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=400',
      description: 'Brotherhood events, formals, and social gatherings',
      images: [
        { src: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=600', alt: 'Brotherhood Retreat 2024', caption: 'Brotherhood Retreats' },
        { src: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=600', alt: 'Winter Formal 2024', caption: 'Rush Events' },
        { src: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600', alt: 'Homecoming Tailgate', caption: 'Parent Alumni Tailgate' },
        { src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600', alt: 'Spring Social', caption: 'Date Parties' },
        { src: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=600', alt: 'Bid Day Celebration', caption: 'Welcoming New Brothers' },
        { src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600', alt: 'Leadership Conference', caption: 'National Retreat Trips' },
        { src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600', alt: 'Leadership Conference', caption: 'Social Events' },
        { src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600', alt: 'Leadership Conference', caption: 'Brother Appreciation' }
      ]
    },
    {
      id: 'philanthropy',
      title: 'Philanthropy & Service',
      coverImage: 'https://images.unsplash.com/photo-1577563908411-5077b6dc7624?w=400',
      description: 'Community service and charitable activities',
      images: [
        { src: 'https://images.unsplash.com/photo-1577563908411-5077b6dc7624?w=600', alt: 'Community Service Day', caption: 'Habitat for Humanity' },
        { src: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?w=600', alt: 'Campus Clean-Up', caption: "Bully's Closet & Pantry" },
        { src: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=600', alt: 'Bullying\'s Closet', caption: 'StarkVegas Auto Show - Jimmy V Foundation' },
        { src: 'https://images.unsplash.com/photo-1593113598332-cd288d649433?w=600', alt: 'Food Drive', caption: 'Other Volunteering' }
      ]
    },
    {
      id: 'campus',
      title: 'Campus Life',
      coverImage: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400',
      description: 'Daily life and activities at MSU',
      images: [
        { src: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600', alt: 'MSU Campus', caption: 'Beautiful Starkville Campus' },
        { src: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=600', alt: 'Study Sessions', caption: 'Academic Excellence' },
        { src: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=600', alt: 'Chapter House', caption: 'ATO Chapter House' },
        { src: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=600', alt: 'Football Games', caption: 'MSU Bulldogs Football' },
        { src: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=600', alt: 'Library Study', caption: 'Late Night Studying' }
      ]
    },
    {
      id: 'brotherhood',
      title: 'Brotherhood',
      coverImage: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400',
      description: 'Moments that define our brotherhood',
      images: [
        { src: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=600', alt: 'Brotherhood Ceremony', caption: 'Initiation Ceremony' },
        { src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600', alt: 'Leadership Meeting', caption: 'Chapter Leadership' },
        { src: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=600', alt: 'Alumni Reunion', caption: 'Alumni Homecoming' },
        { src: 'https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=600', alt: 'Team Building', caption: 'Brotherhood Activities' },
        { src: 'https://images.unsplash.com/photo-1543326727-cf6c39e8f84c?w=600', alt: 'Award Ceremony', caption: 'Achievement Recognition' }
      ]
    }
  ];

  return (
    <section className="gallery-section">
      <div className="content">
        <div className="gallery-header">
          <h2>Photo Gallery</h2>
          <p>Explore our brotherhood through moments captured in time</p>
        </div>

        <div className="albums-grid">
          {albums.map((album) => (
            <Link to={`/gallery/${album.id}`} className="album-card" key={album.id}>
              <div className="album-cover">
                <img src={album.coverImage} alt={album.title} />
                <div className="album-overlay">
                  <div className="album-info">
                    <h3>{album.title}</h3>
                    <p>{album.description}</p>
                    <span className="photo-count">{album.images.length} photos</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

const AlbumView = () => {
  const { albumId } = useParams();
  const [lightboxOpen, setLightboxOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState(null);

  const albums = [
    {
      id: 'events',
      title: 'Events & Socials',
      coverImage: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=400',
      description: 'Brotherhood events, formals, and social gatherings',
      images: [
        { src: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=800', alt: 'Brotherhood Retreat 2024', caption: 'Annual Brotherhood Retreat' },
        { src: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=800', alt: 'Winter Formal 2024', caption: 'Winter Formal Gala' },
        { src: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800', alt: 'Homecoming Tailgate', caption: 'MSU Homecoming Celebration' },
        { src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800', alt: 'Spring Social', caption: 'Spring Semester Social Event' },
        { src: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800', alt: 'Bid Day Celebration', caption: 'Welcoming New Brothers' }
      ]
    },
    {
      id: 'philanthropy',
      title: 'Philanthropy & Service',
      coverImage: 'https://images.unsplash.com/photo-1577563908411-5077b6dc7624?w=400',
      description: 'Community service and charitable activities',
      images: [
        { src: 'https://images.unsplash.com/photo-1577563908411-5077b6dc7624?w=800', alt: 'Community Service Day', caption: 'Habitat for Humanity Build' },
        { src: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?w=800', alt: 'Campus Clean-Up', caption: 'Quarterly Campus Maintenance' },
        { src: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=800', alt: 'Bullying\'s Closet', caption: 'Adaptive Sports Coaching' },
        { src: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=800', alt: 'ATO Car Show', caption: 'Annual Charity Car Show' },
        { src: 'https://images.unsplash.com/photo-1593113598332-cd288d649433?w=800', alt: 'Food Drive', caption: 'Community Food Collection' }
      ]
    },
    {
      id: 'campus',
      title: 'Campus Life',
      coverImage: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400',
      description: 'Daily life and activities at MSU',
      images: [
        { src: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800', alt: 'MSU Campus', caption: 'Beautiful Starkville Campus' },
        { src: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800', alt: 'Study Sessions', caption: 'Academic Excellence' },
        { src: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800', alt: 'Chapter House', caption: 'ATO Chapter House' },
        { src: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=800', alt: 'Football Games', caption: 'MSU Bulldogs Football' },
        { src: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800', alt: 'Library Study', caption: 'Late Night Studying' }
      ]
    },
    {
      id: 'brotherhood',
      title: 'Brotherhood',
      coverImage: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400',
      description: 'Moments that define our brotherhood',
      images: [
        { src: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800', alt: 'Brotherhood Ceremony', caption: 'Initiation Ceremony' },
        { src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800', alt: 'Leadership Meeting', caption: 'Chapter Leadership' },
        { src: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800', alt: 'Alumni Reunion', caption: 'Alumni Homecoming' },
        { src: 'https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=800', alt: 'Team Building', caption: 'Brotherhood Activities' },
        { src: 'https://images.unsplash.com/photo-1543326727-cf6c39e8f84c?w=800', alt: 'Award Ceremony', caption: 'Achievement Recognition' }
      ]
    }
  ];

  const album = albums.find(a => a.id === albumId);

  if (!album) {
    return (
      <section className="gallery-section">
        <div className="content">
          <h2>Album not found</h2>
          <Link to="/gallery" className="btn btn-primary">Back to Gallery</Link>
        </div>
      </section>
    );
  }

  const openLightbox = (image) => {
    setSelectedImage(image);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setSelectedImage(null);
  };

  return (
    <section className="gallery-section">
      <div className="content">
        <div className="album-view-header">
          <Link to="/gallery" className="back-link">← Back to Gallery</Link>
          <div className="album-info">
            <h2>{album.title}</h2>
            <p>{album.description}</p>
            <span className="photo-count">{album.images.length} photos</span>
          </div>
        </div>

        <div className="album-photos-grid">
          {album.images.map((image, index) => (
            <div className="album-photo-item" key={index} onClick={() => openLightbox(image)}>
              <img src={image.src} alt={image.alt} />
              <div className="photo-overlay">
                <span className="enlarge-icon">🔍</span>
              </div>
              <p className="photo-caption">{image.caption}</p>
            </div>
          ))}
        </div>
      </div>

      {lightboxOpen && selectedImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>×</button>
            <img src={selectedImage.src} alt={selectedImage.alt} className="lightbox-image" />
            <p className="lightbox-caption">{selectedImage.caption}</p>
          </div>
        </div>
      )}
    </section>
  );
};

const Contact = () => (
  <section className="section">
    <h1 style={{textAlign: 'center'}}>Contact Us</h1>
    <div className="contact-content">
      <div className="contact-info">
        <h3>Get in Touch</h3>
        <div className="contact-item">
          <strong>Chapter House:</strong>
          <a href='https://maps.google.com/?q=115 C Q Sheely Cir, Starkville, MS 39759' target="_blank" rel="noopener noreferrer">
            <p>115 C Q Sheely Cir <br/>Starkville, MS 39759, United States</p>
          </a>
        </div>
        <div className="contact-item">
          <strong>Rush Chair:</strong>
          <p>atomissstate@gmail.com<br />(662) 325-0000</p>
        </div>
        <div className="contact-item">
          <strong>President:</strong>
          <p>atomissstate@gmail.com</p>
        </div>
        
        <div className="social-links">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://www.instagram.com/ato_msu/" target="_blank" rel="noopener noreferrer">
              <span className="social-icon">📸</span> Instagram
            </a>
            <a href="https://www.facebook.com/profile.php?id=100039860631694&sk=photos" target="_blank" rel="noopener noreferrer">
              <span className="social-icon">📘</span> Facebook
            </a>
          </div>
        </div>
      </div>

      <div className="contact-form">
        <h3>Send us a Message</h3>
        <form>
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <input type="text" placeholder="Subject" required />
          <textarea rows="5" placeholder="Your Message" required></textarea>
          <button type="submit">Send Message</button>
        </form>
      </div>
    </div>
  </section>
);

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <Router>
      <div className="App">
        {/* Navigation */}
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="nav-brand">
              <img style={{ width: '200px', height: '50px' }} src={atoLogo} alt="Alpha Tau Omega Logo" />
              {/* <span className="brand-text">ΑΤΩ</span>
              <span className="brand-subtitle">Mississippi State</span> */}
            </Link>
            
            <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
              <Link to="/" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Home</Link>
              <Link to="/philanthropy" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Philanthropy</Link>
              <Link to="/events" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Events</Link>
              <Link to="/alumni" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Alumni</Link>
              <Link to="/gallery" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Gallery</Link>
              <Link to="/contact" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
            </div>

            <div className="hamburger" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/philanthropy" element={<Philanthropy />} />
            <Route path="/events" element={<Events />} />
            <Route path="/alumni" element={<Alumni />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/gallery/:albumId" element={<AlbumView />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer className="footer">
          <div className="footer-content">
            <div className="footer-section">
              <h4 style={{ color: 'black' }}>Alpha Tau Omega</h4>
              <p>Mississippi State University</p>
              <p>Building Better Men Since 1865</p>
            </div>
            <div className="footer-section">
              <h4 style={{ color: 'black' }}>Quick Links</h4>
              <Link to="/events">Upcoming Events</Link>
              <Link to="/contact">Contact Us</Link>
              <Link to="/alumni">Alumni Network</Link>
            </div>
            <div className="footer-section">
              <h4 style={{ color: 'black' }}>Powered by</h4>
              <a href="https://taskbridgesolutions.com"><strong>TaskBridge Solutions</strong></a>
              <p>Building digital experiences</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Alpha Tau Omega - Mississippi State University. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
